import React, { Fragment } from 'react'
import { IconS24Building524 } from '@is24/cosma-ui-icons'
import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { SCREEN_BASIC_INFO, SCREENS } from '../../../../../services/domain/wizardScreens'
import { BasicInfoScreenValidationResult } from '../../../../../@types/validation-types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { FieldProps, TooltipTypes } from '../../../../../@types/types'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import { ScreenTooltip } from '../../../../common/display/screenTooltip/ScreenTooltip'
import { isWebView } from '../../../../../utils/navigation'
import styles from '../../../../common/containers/screenLayout/ScreenLayout.module.css'

const screen = SCREENS[SCREEN_BASIC_INFO]
export type BasicInfoWrapperProps = FieldProps<BasicInfoScreenValidationResult>
export type BasicInfoAdditionalProps = {
  screenTooltipKey?: string
  properties: ((basicInfoWrapperProps: BasicInfoWrapperProps) => React.JSX.Element)[]
}

const BasicInfo: React.FC<InsertionFlowScreensProps<BasicInfoScreenValidationResult> & BasicInfoAdditionalProps> = ({
  flowInformation,
  insertionData,
  validationMessages,
  properties,
  onChange,
  onNavigate,
  doReset,
  screenTooltipKey,
}) => {
  const isMobile = isWebView()
  const headerKey = 'wizard.screen.basicInfo.header'
  const hideTooltips = flowInformation?.options?.isWaitingListFlow
  const deskTooltip =
    screenTooltipKey && !hideTooltips ? (
      <ScreenTooltip tooltipType={TooltipTypes.DESKTOP} tooltipKey={screenTooltipKey} />
    ) : undefined

  const wrapperProps: FieldProps<BasicInfoScreenValidationResult> = {
    flowInformation: flowInformation,
    validationMessages: validationMessages,
    insertionData: insertionData,
    screenName: screen.name,
    screenId: screen.id,
    onChange: onChange,
    doReset: doReset,
  }

  return (
    <>
      <ScreenContainer
        className={isMobile ? 'margin-bottom-xxl' : ''}
        disableMarginBottom={isMobile}
        containerId={screen.id}
        onNavigate={onNavigate}
        screen={screen}
      >
        <ScreenLayout
          id={`${screen.id}-desk-tooltip`}
          headline={headerKey}
          deskTooltip={deskTooltip}
          headerIcon={<IconS24Building524 />}
          className='grid grid-flex gutter-vertical-l'
          screenName={screen.name}
          sectionClassName={styles.allowOverflow}
        >
          {properties.map((item, index) => (
            <Fragment key={index}>{item(wrapperProps)}</Fragment>
          ))}
        </ScreenLayout>
      </ScreenContainer>
    </>
  )
}

export default BasicInfo
